<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top-off" style="background-color: #ffffff">
	<!-- 		 	     -->
	<!-- Person Selector -->
	<!-- 			 	 -->
	<div>
		<caass-personselector
			[AudienceID]="1"
			[CanSwitchAudience]="true"
			[ShowAllSchools]="false"
			[MultiSelect]="false"
			[buttonMultiSelectProcessCaption]="'Add'"
		></caass-personselector>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onChangeStatus()" [disabled]="isBusy == true">Change Status</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Total cards printed: {{ lstBarcodes.length }}</label
		><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
	</div>
</div>

<!-- 					  -->
<!-- Display Barcodes 	  -->
<!-- 					  -->
<div class="barcode-table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->
	<p-table
		#mydt
		[value]="lstBarcodes"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedBarcodeItem"
		dataKey="IDCardID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50, 100]"
	>
		<ng-template pTemplate="header">
			<!-- 				-->
			<!-- Filter Section -->
			<!-- 				-->
			<tr>
				<th>
					<div class="barcode-filter-row-group">
						<!-- 				   -->
						<!-- Display When Busy -->
						<!-- 				   -->
						<div [style.display]="isBusy == true ? 'block' : 'none'" style="width: 20px">
							<img class="busy-img" src="assets/images/loading.gif" />
						</div>
						<div [style.display]="isBusy == false ? 'block' : 'none'" style="width: 20px"></div>
						<!-- Show/Hide Buttons -->
						<div class="p-d-flex" style="margin-left: 15px" [style.display]="isShowEmbeddedID == false ? 'block' : 'none'">
							<button
								pButton
								style="width: 100px"
								label="Embedded ID"
								class="p-button-outlined"
								icon="pi pi-plus-circle"
								(click)="ontoggleEmbeddedID()"
							></button>
						</div>
						<div class="p-d-flex" style="margin-left: 15px" [style.display]="isShowEmbeddedID == true ? 'block' : 'none'">
							<button
								pButton
								style="width: 100px"
								label="Embedded ID"
								class="p-button-outlined"
								icon="pi pi-minus-circle"
								(click)="ontoggleEmbeddedID()"
							></button>
						</div>
					</div>
				</th>

				<th [style.display]="isShowEmbeddedID == true ? 'table-cell' : 'none'"></th>
				<!-- Placeholder -->

				<th style="text-align: right">
					<div class="p-d-flex">
						<button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash" (click)="onClearFilters()"></button>
					</div>
				</th>

				<th>
					<p-columnFilter field="CardName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterCardName
								[ngModel]="value"
								[options]="lstCardNames"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="IDCardStockDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterCardStock
								[ngModel]="value"
								[options]="lstCardStocks"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="BarcodeStatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterCardStatus
								[ngModel]="value"
								[options]="lstCardStatuses"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<div class="barcode-filter-row-group">
						<!-- Show/Hide Buttons -->
						<div class="p-d-flex" style="margin-left: 5px" [style.display]="isShowExpireDate == false ? 'block' : 'none'">
							<button
								pButton
								style="width: 100px"
								label="Expire Date"
								class="p-button-outlined"
								icon="pi pi-plus-circle"
								(click)="ontoggleExpireDate()"
							></button>
						</div>
						<div class="p-d-flex" style="margin-left: 5px" [style.display]="isShowExpireDate == true ? 'block' : 'none'">
							<button
								pButton
								style="width: 100px"
								label="Expire Date"
								class="p-button-outlined"
								icon="pi pi-minus-circle"
								(click)="ontoggleExpireDate()"
							></button>
						</div>
					</div>
				</th>
				<!-- Placeholder -->

				<th [style.display]="isShowExpireDate == true ? 'table-cell' : 'none'"></th>
				<!-- Placeholder -->
			</tr>

			<!-- 			  -->
			<!-- Sort Section -->
			<!-- 			  -->
			<tr>
				<th pSortableColumn="CAASSBarcode">Barcode<p-sortIcon field="CAASSBarcode"></p-sortIcon></th>
				<th pSortableColumn="UID">UID<p-sortIcon field="UID"></p-sortIcon></th>
				<th [style.display]="isShowEmbeddedID == true ? 'table-cell' : 'none'" pSortableColumn="MTAID">
					Embedded ID<p-sortIcon field="MTAID"></p-sortIcon>
				</th>
				<th pSortableColumn="CardName">Card Name<p-sortIcon field="CardName"></p-sortIcon></th>
				<th pSortableColumn="IDCardStockDesc">Card Stock<p-sortIcon field="IDCardStockDesc"></p-sortIcon></th>
				<th pSortableColumn="BarcodeStatusDesc">Card Status<p-sortIcon field="BarcodeStatusDesc"></p-sortIcon></th>
				<th pSortableColumn="IssueDate">Issue Date<p-sortIcon field="IssueDate"></p-sortIcon></th>
				<th [style.display]="isShowExpireDate == true ? 'table-cell' : 'none'" pSortableColumn="ExpirationDate">
					Expire Date<p-sortIcon field="ExpirationDate"></p-sortIcon>
				</th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rBarcodeItem>
			<tr [pSelectableRow]="rBarcodeItem">
				<td>
					<div class="barcode-table-data1 barcode-table-black" style="font-weight: bold">
						{{ rBarcodeItem.CAASSBarcode }}
					</div>
				</td>

				<td>
					<div class="barcode-table-data1 barcode-table-black">
						{{ rBarcodeItem.UID }}
					</div>
				</td>

				<td [style.display]="isShowEmbeddedID == true ? 'table-cell' : 'none'">
					<div class="barcode-table-data1 barcode-table-black">
						{{ rBarcodeItem.MTAID }}
					</div>
				</td>

				<td>
					<div class="barcode-table-data2 barcode-table-black">
						{{ rBarcodeItem.CardName }}
					</div>
				</td>

				<td>
					<div class="barcode-table-data2 barcode-table-black">
						{{ rBarcodeItem.IDCardStockDesc }}
					</div>
				</td>

				<td>
					<div
						[ngClass]="{
							'barcode-table-data2 cgreen': rBarcodeItem.IDStatusID == 0,
							'barcode-table-data2 cred': rBarcodeItem.IDStatusID == 1 || rBarcodeItem.IDStatusID == 2 || rBarcodeItem.IDStatusID == 9,
							'barcode-table-data2 corange': rBarcodeItem.IDStatusID == 3 || rBarcodeItem.IDStatusID == 4 || rBarcodeItem.IDStatusID == 7,
							'barcode-table-data2 cblack':
								rBarcodeItem.IDStatusID == 5 || rBarcodeItem.IDStatusID == 6 || rBarcodeItem.IDStatusID == 8 || rBarcodeItem.IDStatusID > 9
						}"
					>
						{{ rBarcodeItem.BarcodeStatusDesc }}
					</div>
				</td>

				<td>
					<div>
						{{ rBarcodeItem.IssueDate | date : "MMM d, y, h:mm a" }}
					</div>
				</td>

				<td [style.display]="isShowExpireDate == true ? 'table-cell' : 'none'">
					<div [style.display]="rBarcodeItem.ExpirationDate != '0001-01-01T00:00:00' ? 'table-cell' : 'none'">
						{{ rBarcodeItem.ExpirationDate | date : "MMM d, y, h:mm a" }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						       -->
<!-- Display When No Cards Printed -->
<!-- 						       -->
<div style="padding: 20px" [style.display]="lstBarcodes.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No cards to printed...</label>
</div>
